import { render } from "./front-navbar-preview.vue?vue&type=template&id=61197eb7"
import script from "./front-navbar-preview.vue?vue&type=script&lang=js"
export * from "./front-navbar-preview.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/miqrositio/miqrositio_app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__